import styled from '@emotion/styled';
import { TextInput } from '@partoohub/ui';

export const StyledTextInput = styled(TextInput)`
    flex: 1;
`;
